import React from "react";
import ShoppingCart from "../../assets/shopping_cart-24px.svg";

const MiniCartIcon = (props) => {
  let cartHasItems = props.cartItemCount != null && props.cartItemCount > 0;

  return (
    <span className={`shopping-cart-icon ${cartHasItems ? "clickable" : ""}`}>
      {props.cartIconOverride ? (
        props.cartIconOverride
      ) : (
        <img src={ShoppingCart} alt="Cart Icon"/>
      )}
      {cartHasItems ? (
        <span className="notif-badge">
          <span className="notif-count">
            {props.cartItemCount >= 100 ? "99+" : props.cartItemCount}
          </span>
        </span>
      ) : null}
    </span>
  );
};

export default MiniCartIcon;
